
import { defineComponent } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import Dropdown, { DropdownMenu, DropdownItem } from '@/components/common/Dropdown';
import PublicPortfolioConfirmCancelRequest from '@/components/partials/public-portfolio/PublicPortfolioConfirmCancelRequest.vue';
import PublicPortfolioConfirmRemoveConnection from '@/components/partials/public-portfolio/PublicPortfolioConfirmRemoveConnection.vue';
import PublicPortfolioHeroMenuItem from '@/components/partials/public-portfolio/PublicPortfolioHeroMenu/PublicPortfolioHeroMenuItem.vue';
import PublicPortfolioConnectionActionsMixin from '@/components/partials/public-portfolio/PublicPortfolioConnectionActions/PublicPortfolioConnectionActionsMixin';
import HistoryIcon from '@/assets/svg/history-alt.vue.svg';
import LinkIcon from '@/assets/svg/link-h.vue.svg';
import MoreIcon from '@/assets/svg/more.vue.svg';
import { getPortfolioUrl } from '@/utils/routes';
import { publicPortfolioPopUps } from '@/components/partials/public-portfolio/constants';

export default defineComponent({
  name: 'PublicPortfolioHeroMenu',
  components: {
    BravadoButtonV3,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    HistoryIcon,
    LinkIcon,
    MoreIcon,
    PublicPortfolioConfirmCancelRequest,
    PublicPortfolioConfirmRemoveConnection,
    PublicPortfolioHeroMenuItem,
  },
  mixins: [PublicPortfolioConnectionActionsMixin],
  computed: {
    showMenu(): boolean {
      return this.$auth.loggedIn && this.$auth.user.slug !== this.$route.params.slug;
    },
    menuClass() {
      return {
        'public-portfolio-hero-menu': true,
        'public-portfolio-hero-menu--wide': (this.isRequesterView && this.isRequestSent) || this.isConnected,
      };
    },
  },
  methods: {
    async copyProfileLinkToClipboard() {
      try {
        this.$analytics.logEvent('public-portfolio__copy_portfolio_url__button__click');

        const profileLink = getPortfolioUrl(this.$route.params.slug);

        await navigator.clipboard.writeText(profileLink);
        this.$cancelableNotice({ message: 'Profile link copied to the clip board' });
      } catch (e) {
        this.$notice.error('Failed to copy profile link, try again in few minutes.', e);
        this.$sentryUtils.error(e);
      }
    },
    confirmCancelConnectionRequest() {
      this.$modal.show(publicPortfolioPopUps.CONFIRM_CANCEL_REQUEST);
    },
    confirmRemoveConnection() {
      this.$modal.show(publicPortfolioPopUps.CONFIRM_REMOVE_CONNECTION);
    },
  },
});
